import { API_BASE_URL } from 'constants/apiConf';
import { preparePath } from 'utils/preparePath';

export const URLS = { CHAT: 'chat' };

export async function sendMessage(messages, onMessage) {
  const evtSource = new EventSource(
    preparePath(`${API_BASE_URL}/api/v1/${URLS.CHAT}`, {}, messages),
    { withCredentials: true },
  );

  // eslint-disable-next-line consistent-return
  evtSource.onmessage = ({ data }) => {
    const parsed = JSON.parse(data);
    if (parsed.choices?.[0]?.finish_reason === 'stop') {
      onMessage('[DONE]');
      return evtSource.close();
    }
    parsed.choices?.forEach(c => c?.delta?.content && onMessage(c.delta.content));
  };

  evtSource.onerror = () => {
    evtSource.close();
    onMessage('[ERROR]');
  };

  return new Promise(resolve => { evtSource.onclose = resolve; });
}
